import request from '@/config/axios'

export interface LegalWorkbenchConfigVO {
  id?: number
  title: string
  subtitle: string
  caseTypesJson: string
  caseStagesJson: string
  evidenceTypesJson: string
  intakeFieldsJson: string
  crmIntegrationJson?: string
  documentEnabled: boolean
  analysisEnabled: boolean
  disclaimer: string
}

export interface LegalCaseArtifactVO {
  id: number
  runId?: number
  artifactType?: string
  name?: string
  fileUrl?: string
  hasContent?: boolean
  content?: string
}

export interface LegalCaseVO {
  id: number
  title?: string
  caseType?: string
  clientName?: string
  opposingParty?: string
  caseStage?: string
  conflictStatus?: string
  paymentStatus?: string
  crmClueId?: number
  crmBusinessId?: number
  latestTeamRunId?: number
  artifacts?: LegalCaseArtifactVO[]
}

export const LegalWorkbenchConfigApi = {
  get: async (): Promise<LegalWorkbenchConfigVO | null> =>
    request.get({ url: '/ai/lawyer/workbench-config/get' }),
  save: async (data: LegalWorkbenchConfigVO): Promise<number> =>
    request.put({ url: '/ai/lawyer/workbench-config/save', data })
}

export const LegalCaseApi = {
  list: async (ownerId?: number): Promise<LegalCaseVO[]> =>
    request.get({ url: '/ai/lawyer/case/list', params: { ownerId } }),
  get: async (id: number): Promise<LegalCaseVO> =>
    request.get({ url: '/ai/lawyer/case/get', params: { id } }),
  progress: async (caseId: number) =>
    request.get({ url: '/ai/lawyer/case/progress', params: { caseId } }),
  markPaid: async (caseId: number) =>
    request.post({ url: '/ai/lawyer/case/mark-paid', data: { caseId } }),
  artifacts: async (caseId: number): Promise<LegalCaseArtifactVO[]> =>
    request.get({ url: '/ai/lawyer/case/artifacts', params: { caseId } }),
  artifact: async (caseId: number, artifactId: number): Promise<LegalCaseArtifactVO> =>
    request.get({ url: '/ai/lawyer/case/artifact', params: { caseId, artifactId } })
}
